import { render, staticRenderFns } from "./doTopic.vue?vue&type=template&id=345cc80e&scoped=true&"
import script from "./doTopic.vue?vue&type=script&lang=js&"
export * from "./doTopic.vue?vue&type=script&lang=js&"
import style0 from "./doTopic.vue?vue&type=style&index=0&id=345cc80e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345cc80e",
  null
  
)

export default component.exports